import {EventEmitter} from 'events'

const NoticeEmitter = new EventEmitter();
NoticeEmitter.setMaxListeners(100);
export default NoticeEmitter;
